module.exports = __webpack_public_path__ + "img/活动规则top.984e1459.png";